export default __webpack_public_path__ + "static/media/AddEdit.1860430e.svg";